// Petty cash routes (under accounting app)

// Users with pettycash or accounting access can view petty cash
const meta = { requiresAuth: true, app: ["pettycash", "accounting"] };

const routes = [
  {
    path: "/accounting/petty-cash",
    name: "PettyCashDaybook",
    component: () => import("@/views/pettycash/PettyCashHome.vue"),
    meta,
  },
  {
    path: "/accounting/petty-cash/ledger",
    name: "PettyCashLedger",
    component: () => import("@/views/pettycash/PettyCashHome.vue"),
    meta,
  },
  {
    path: "/accounting/petty-cash/journal",
    name: "PettyCashJournal",
    component: () => import("@/views/pettycash/PettyCashHome.vue"),
    meta,
  },
];

export default routes;
